// these values are correspond to backend msg_type
export enum WarningLevel {
  Info = 0,
  Warning = 1,
}

export interface Warning {
  message: string;
  level: WarningLevel;
}

export interface ResultStat {
  bud: number;
  conz: number;
  viab: number;
  areaAlive: object;
  areaDead: object;
  countAlive: object;
  countBudding: object;
  countDead: object;
  countTotal: object;
  meanDia: { hist: number[][] };
  meanDiaDead: { hist: number[][] };
  meanDiaAlive: { hist: number[][] };
  densityWarning: Warning | null;
  viabilityWarning: Warning | null;
  concentrationWarning: Warning | null;
}
